import React, {Fragment, Component} from 'react';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import {Box} from '@mui/material';
import {SchemaUtils} from "../../util/SchemaUtils";
import PayPal from './PayPal';
import Stripe from './Stripe';
import { PaymentInfo, PaymentInfoAmount, PaymentInfoAmountBox, PaymentInfoTitle, PaymentWrapper, PaymentWrapperPaypal } from '../../styles/jss/components/review';
import { AdditionalText, InlineList, InlineListItem, InlineListLink } from '../../styles/jss/global';

interface IPaymentProperties {
    componentProps: any;
    handleShowErrorPage: any;
    handlePaymentProcessing: any;
    handleSuccessPurchase: any;
}

export default class Payment extends Component<IPaymentProperties, {}> {
    render() {
        let amountToPay = SchemaUtils.getPaymentPrice(
            this.props.componentProps.app.payment.config.paymentRules,
            this.props.componentProps.appData,
            this.props.componentProps.app.payment.config.price);

        const Comp = this.props.componentProps.app.payment.provider === 'paypal' ? PaymentWrapperPaypal : PaymentWrapper

        return (
            <Fragment>
                <Comp>
                    <PaymentInfo>
                        <PaymentInfoTitle variant={'h4'} component={'h4'}>Summary:</PaymentInfoTitle>
                        <PaymentInfoAmountBox>
                            <ShoppingCartOutlinedIcon />
                            <PaymentInfoAmount>{this.props.componentProps.app.payment.config.currency} {amountToPay}</PaymentInfoAmount>
                        </PaymentInfoAmountBox>
                    </PaymentInfo>

                    {this.props.componentProps.app.payment.provider === 'paypal' &&
                        <PayPal
                            componentProps = {this.props.componentProps}
                            amountToPay = {amountToPay}
                            handleShowErrorPage = {this.props.handleShowErrorPage}
                            handleSuccessPurchase = {this.props.handleSuccessPurchase}
                        />
                    }

                    {this.props.componentProps.app.payment.provider === 'stripe' &&
                        <Stripe
                            componentProps = {this.props.componentProps}
                            amountToPay = {amountToPay}
                            handleShowErrorPage = {this.props.handleShowErrorPage}
                            handlePaymentProcessing = {this.props.handlePaymentProcessing}
                            showAgreement = {this.props.componentProps.app.payment.config.userAgreementUrl.length > 0}
                        />
                    }

                    <Box>
                        <AdditionalText>{this.props.componentProps.app.payment.config.description}</AdditionalText>

                        <InlineList sx={{textAlign: "center"}}>
                            {this.props.componentProps.app.payment.config.privacyPolicyUrl &&
                                <InlineListItem>
                                    <InlineListLink href={this.props.componentProps.app.payment.config.privacyPolicyUrl} title="Privacy Policy" target="_blank" rel="noopener noreferrer">Privacy Policy</InlineListLink>
                                </InlineListItem>
                            }
                            {this.props.componentProps.app.payment.config.userAgreementUrl &&
                                <InlineListItem>
                                    <InlineListLink href={this.props.componentProps.app.payment.config.userAgreementUrl} title="User Agreement" target="_blank" rel="noopener noreferrer">User Agreement</InlineListLink>
                                </InlineListItem>
                            }
                        </InlineList>
                    </Box>
                </Comp>
            </Fragment>
        );
    }
}